import React, { useCallback, useState } from 'react';

import { withSnackbar } from 'notistack';
import appConstants from '../../../appConstants';
import Filters from './CategoryFilter';
import GridsContainer from './grid';
import useForecastData from './useForecastData';
import { getDefaultValueForFilters, includeCombinedData } from './util';

const filterOptions = [
  {
    label: 'All Bills',
    value: 0,
    filter: 'all'
  },
  {
    label: 'At DT',
    value: 1,
    filter: 'atDt'
  },
  {
    label: 'Enroute to DT',
    value: 2,
    filter: 'enrouteToDt'
  },
  {
    label: 'Unappointed',
    value: 3,
    filter: 'unappointed'
  },
  {
    label: 'Late Due Service Bills',
    value: 4,
    filter: 'lateDue'
  },
  {
    label: 'Customer Traps',
    value: 5,
    filter: 'customerTrap'
  }, 
  {
    label: 'Other Bills',
    value: 6,
    filter: 'other'
  }
];

const initialDataValue = getDefaultValueForFilters(filterOptions)

const TerminalView = ({ terminal, enqueueSnackbar, userData, quickFilter }) => {
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0]);
  const [currentTerminal, setCurrentTerminal] = useState(terminal);
  const headerId ="TerminalView";
  const showErrorMessage = (dataField) => {
    enqueueSnackbar(`Error while fetching ${dataField} for terminal ${currentTerminal.terminalCode}`, { variant: 'error'})
  }

  const { customers, bills, refreshData, isCustomersLoading, isBillsLoading } = useForecastData({
    defaultValue: initialDataValue,
    customerAPI: 'GetCustomersForTerminalForecast',
    billsAPI: 'GetShipmentForecastForTerminal',
    queryString: `terminalCode=${currentTerminal.terminalCode}&terminalId=${currentTerminal.terminalId}`,
    showErrorMessage,
    headerId,
    responseDataModifier: includeCombinedData
  });

  const onChange = useCallback((filter) => {
    setSelectedFilter(filter);
  }, []);

  const onTerminalChange = useCallback((updatedTerminal) => {
    if (!updatedTerminal) return;
    if (updatedTerminal.terminalCode !== currentTerminal.terminalCode) {
      setCurrentTerminal(updatedTerminal);
    }
  }, [currentTerminal]);

  const filteredCustomers = customers[selectedFilter.filter]
  const filteredBills = bills[selectedFilter.filter];
  return (
    <>
      <Filters
        onChange={onChange}
        filterOptions={filterOptions}
        userData={userData}
        currentTerminalId={currentTerminal.terminalId}
        onTerminalChange={onTerminalChange}
        handleRefreshClick={refreshData}
        headerId={headerId}
      />
      <GridsContainer
        activeFilter={`${currentTerminal.code}_${selectedFilter.filter}`}
        quickFilter={quickFilter}
        customers={{
          gridName: appConstants.gridNames.shipmentForecastTerminalCustomers,
          data: filteredCustomers
        }}
        bills={{
          gridName: appConstants.gridNames.shipmentForecastTerminalBills,
          data: filteredBills
        }}
        isCustomersLoading={isCustomersLoading}
        isBillsLoading={isBillsLoading}
      />
    </>
  );
};

export default withSnackbar(TerminalView);
